import { useCallback, useState } from 'react';

/**
 * Hooks helper toggling boolean state
 *
 */
const useToggle = () => {
  const [active, setActive] = useState<boolean>(false);

  // toggling `active` state
  const toggleActive = useCallback(() => {
    setActive((prevState) => !prevState);
  }, []);

  // expose state and function side-effect
  return {
    active,
    toggleActive,
    setActive
  };
};

export default useToggle;
